import {ref} from "@vue/composition-api";
import {UserEntityInterface} from "@tool/tool.types";

const user = ref<UserEntityInterface>({
    id: 'guest',
    name_first: 'guest',
    name_last: null,
    email: 'guest@utmtool.com',
    current_team_id: null,
    current_project_id: null,
});

const billing_trial_ends_at = ref<null | string>(null);
const loadingOverlay = ref(false);

/**
 * Main store
 */
export default function useAppStore() {
    return {
        user,
        billing_trial_ends_at,
        loadingOverlay
    }
}